module.exports = __webpack_public_path__ + "img/logo-titre.6ae339e8.png";